import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "12",
  height: "12",
  fill: "none",
  viewBox: "0 0 12 12"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#AFB0B0",
      d: "M11 5H1a1 1 0 0 0 0 2h10a1 1 0 1 0 0-2"
    }, null, -1),
    _createElementVNode("path", {
      fill: "#AFB0B0",
      d: "M7 11V1a1 1 0 0 0-2 0v10a1 1 0 1 0 2 0"
    }, null, -1)
  ]))]))
}
export default { render: render }